import React from 'react';
import InputBox from '../../components/InputBox'
import * as Filters from '../../helpers/Filters'

class IntBox extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { 
        
        var msg = this._input.validate(); 
        
        if (msg == null){
            const val = this._input.getValue();

            if (val !== ''){
                const intVal = parseInt(val, 0);

                if (intVal > this.props.maxValue)
                    msg = "Invalid value (max " + this.props.maxValue + ").";
                else if (intVal < this.props.minValue)
                    msg = "Invalid value (min " + this.props.maxValue + ").";
            }
        }

        return msg;
    }
	
	// Private
	_filter = (key) => {
		if (this.props.positiveOnly)
			return Filters.positiveIntegersOnly(key);

		return Filters.integersOnly(key);
	}

	// React
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.disabled !== this.props.disabled);
	}

	render() {
		const props = {
			...this.props,
			filter: this._filter,
			className: this.props.className + " text-right"
		}

		return (<InputBox {...props} ref={(input) => this._input = input} />)
	}
}

export default IntBox;

// Mark this as a form component
IntBox.defaultProps = {
	formControl: true,
	managed: false,
    maxLength: 10, 
    maxValue: 2147483647, 
    minValue: -2147483647
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/intBox/IntBox.js